import { ChatFriendsError } from "@/plugins/errors/chat-errors";
import i18n from "@/main";

export const validateChatFriendsError = error => {
  const { t } = i18n.global;

  if (error.status === 400) {
    throw new ChatFriendsError(t("wegow.chat.error"));
  }
};
